import React, { useContext, useEffect } from 'react'
import { MapContext } from '../component'
import { AnyLayer, MapLayerMouseEvent } from 'mapbox-gl'
import { eventtype, InterfaceMapBox } from '../types'

export const Layer = ({
  add = false,
  id,
  below,
  options,
  modify = false,
  events
}: {
  add?: boolean
  id?: string
  below?: string
  options?: AnyLayer | { id: string }
  modify?: boolean
  events?: { [key: string]: (e: MapLayerMouseEvent, map: mapboxgl.Map) => void }
}) => {
  const map = useContext(MapContext)
  useEffect(() => {
    if (map) {
      map.on('load', () => {
        if (add) map.addLayer(options, below)
      })
      if (modify) {
        if (events && Object.keys(events).length > 0 && id) {
          Object.keys(events).forEach((ev: string) => {
            map.on(ev as eventtype, id, (e: MapLayerMouseEvent) =>
              events[ev](e, map)
            )
          })
        }
      }
    }
  }, [])

  return null
}
